const Contact = () => import(/* webpackChunkName: "Contact" */ '@/assets/js/src/modules/contact/_views/Contact.vue')

export default [
    {name: 'Contact', path: '/contact', meta: {uiType: 'Overlay',}, component: Contact,},
]
